<template>
  <div class="activePage" v-loading="loading">
    <backgroundTop title="遵义医科大学附属医院" />
    <el-card>
      <div class="infoTitle">{{ this.activeInfo.type_name }}</div>
      <div class="notice">
        <p class="title">
          注意事项
        </p>
        <p><span>编制：</span>{{ this.activeInfo.pre_info_yes }}</p>
        <p><span>非编制：</span>{{ this.activeInfo.pre_info_no }}</p>
      </div>
      <div class="btnDiv">
        <!-- <el-button type="primary">编制</el-button> -->
        <el-button type="primary" @click="onBianzhi" class="leftBtn">编制</el-button>
        <el-button type="primary" @click="onFeiBianzhi" class="RightBtn">非编制</el-button>
      </div>
    </el-card>
    <CopyRight />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import backgroundTop from '../components/backgroundTop'
import CopyRight from '../components/CopyRight'
export default {
  components: {
    backgroundTop,
    CopyRight
  },
  data() {
    return {
      loading: false,
      activeInfo: [],
      queryInfo: ''
    }
  },
  created() {
    let registration = JSON.parse(sessionStorage.getItem('registration'))
    if (!sessionStorage.getItem('registration')) {
      this.$router.go(-1)
    } else {
      this.queryInfo = registration
      this.getActive()
    }
  },
  methods: {
    ...mapMutations({
      getBianzhi: 'SET_BIANZHI',
      getID: 'SET_SINGUPID'
    }),
    onBianzhi() {
      this.$router.push({
        path: '/Apply',
        query: { bianzhi: '编制', singupId: this.queryInfo.signup_id }
      })
    },
    onFeiBianzhi() {
      this.$router.push({
        path: '/Apply',
        query: { bianzhi: '非编制', singupId: this.queryInfo.signup_id }
      })
    },
    // 获取编制注意事项
    getActive() {
      this.loading = true
      let signupTypeId = this.queryInfo.signup_id
      let params = { signupTypeId: signupTypeId }
      this.$axios
        .get('/api/signup/signupBianzhi', { params })
        .then(result => {
          console.log(result)
          this.loading = false
          const { data: res } = result
          if (res.response_code == 200) {
            this.activeInfo = res.data
            console.log(res.data)
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.el-card {
  margin-top: 25px;
  @include autoInner;
}
.activePage {
  .notice {
    margin-top: 30px;
    border: 1px solid #ccc;
    padding: 24px;
    .title {
      font-size: 24px;
      text-align: center;
      font-weight: 700;
    }
    p {
      padding: 10px 0;
      line-height: 30px;
      span {
        font-weight: 700;
      }
    }
  }
  .infoTitle {
    font-size: 36px;
    text-align: center;
    padding: 10px 0;
  }
  .btnDiv {
    padding: 100px 30px;
    margin-bottom: 100px;
    .leftBtn {
      float: left;
      width: 20%;
      margin-left: 10%;
      height: 80px;
      font-size: 34px;
      box-shadow: 2px 2px 7px 4px #ccc;
    }
    .RightBtn {
      float: right;
      width: 20%;
      margin-right: 10%;
      height: 80px;
      font-size: 34px;
      box-shadow: 2px 2px 7px 4px #ccc;
    }
  }
}
</style>
